export const checkRole = (minRole, role) => {
  return roleCanView()[role].includes(minRole)
}

export const roleCanView = () => ({
  'admin': ['admin', 'accountant', 'user'],
  'accountant': ['accountant', 'user'],
  'user': ['user'],
  'non_user': []
})



// WEBPACK FOOTER //
// ./src/InternalNavigation/roles.js